import React from 'react';
import { SelectLinks } from '../../../../_lib/components/SelectLinks/SelectLinks';
import { FacetLink } from './FacetLink';

type SortByProps = {
  getOptionName: (name: string) => string;
  headline: string;
  sortLinks: FacetLink[];
};

export function SortBy(props: SortByProps) {
  const selectedSort = props.sortLinks.find(item => item.url === null);
  const mappedSortLinksWithTranslations = props.sortLinks.map(item => ({
    ...item,
    name: props.getOptionName(item.name),
  }));
  return (
    <>
      <SelectLinks headline={props.headline} links={mappedSortLinksWithTranslations} />
      <input type="hidden" name="option_sort" value={selectedSort ? selectedSort.name : ''} />
    </>
  );
}
